import { Component, computed, HostListener, inject, input, InputSignal } from '@angular/core';
import { HighchartsChartComponent } from 'highcharts-angular';
import { GenericChart } from 'src/openapi-client';
import { AtomicBlueprintSupported } from '../../shared/atomic/atomic.component';
import { SeriesClickEventObject, XAxisOptions } from 'highcharts';
import { FilterEventService } from '@services/filter-event.service';

export type ExtendedChartOptions = Highcharts.Options & { dataMapping?: Record<string, string> };

@Component({
  selector: 'app-generic-chart',
  imports: [HighchartsChartComponent],
  templateUrl: './generic-chart.component.html',
  styleUrl: './generic-chart.component.scss'
})
export class GenericChartComponent implements AtomicBlueprintSupported<GenericChart> {
  data = input.required<GenericChart>();

  private readonly filterEventService = inject(FilterEventService);

  chartInstance: Highcharts.Chart | undefined;

  chartOptions = computed(() => {
    const result = this.data().content as ExtendedChartOptions;
    const component = this;
    result!.plotOptions = {
      series :{
        className: 'clickable',
        events: {
          click(event: SeriesClickEventObject) {
              const target = {} as Record<string, string[]>;
              target[result.dataMapping![this.userOptions!.name!]] = ['' + event.point.y];
              target[result.dataMapping![(result.xAxis! as XAxisOptions).title!.text!]] = ['' + event.point.category];
              component.filterEventService.dataObjectSelected(target);
              return true;
          },
        },
      }
    };
    return result;
  });
  
  @HostListener('window:resize')
  onResize() {
    this.chartInstance?.reflow();
  }
}
